import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"value":_vm.vat,"label":_vm.$t('VAT'),"items":_vm.data,"item-value":"id","return-object":"","outlined":"","multiple":false,"loading":_vm.loading,"clearable":""},on:{"input":_vm.onSelect},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.getVatName(item).value))])]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.getVatName(item).value))])]}}])},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }